import React, { useState } from "react";
import Modal from "./Modal";
import { urlFor } from "../sanityClient"; // adjust path as needed

const ItemCard = ({ item, onInquire, onCardClick, condensedView, soldOut }) => {
  const [isHovered, setIsHovered] = useState(false);

  const getStatusColor = (status) => {
    switch (status) {
      case "Available":
        return "bg-green-100 text-green-800";
      case "Restocked":
        return "bg-green-100 text-green-800";
      case "Refound":
        return "bg-green-100 text-green-800";
      case "On Hold":
        return "bg-yellow-100 text-yellow-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const formatSeason = (season) => {
    if (!season) return "";
    if (season.toLowerCase().includes("autumn/winter")) return "AW";
    if (season.toLowerCase().includes("spring/summer")) return "SS";
    return season;
  };

  const hasVideo = item.videos && item.videos.length > 0;
  const hasSecondImage = item.images && item.images.length > 1;
  const hasFirstImage = item.images && item.images.length > 0;

  let mainMedia;

  if (isHovered && item.status !== "Sold") {
    if (hasVideo && hasFirstImage) {
      mainMedia = (
        <img
          src={urlFor(item.images[0]).width(800).url()}
          alt={`${item.designer} ${item.year} ${item.season}`}
          className={`absolute inset-0 w-full h-full object-cover ${soldOut ? "opacity-80" : ""}`}
          loading="lazy"
          onContextMenu={(e) => e.preventDefault()}
        />
      );
    } else if (hasSecondImage) {
      mainMedia = (
        <img
          src={urlFor(item.images[1]).width(800).url()}
          alt={`${item.designer} ${item.year} ${item.season}`}
          className={`absolute inset-0 w-full h-full object-cover ${soldOut ? "opacity-80" : ""}`}
          loading="lazy"
          onContextMenu={(e) => e.preventDefault()}
        />
      );
    } else if (hasFirstImage) {
      mainMedia = (
        <img
          src={urlFor(item.images[0]).width(800).url()}
          alt={`${item.designer} ${item.year} ${item.season}`}
          className={`absolute inset-0 w-full h-full object-cover ${soldOut ? "opacity-80" : ""}`}
          loading="lazy"
          onContextMenu={(e) => e.preventDefault()}
        />
      );
    } else {
      mainMedia = <div className="bg-gray-200 h-full w-full"></div>;
    }
  } else {
    if (hasVideo && item.status !== "Sold") {
      mainMedia = (
        <video
          src={item.videos[0]}
          autoPlay
          loop
          muted
          playsInline
          className={`absolute inset-0 w-full h-full object-cover ${soldOut ? "opacity-80" : ""}`}
        />
      );
    } else if (hasFirstImage) {
      mainMedia = (
        <img
          src={urlFor(item.images[0]).width(800).url()}
          alt={`${item.designer} ${item.year} ${item.season}`}
          className={`absolute inset-0 w-full h-full object-cover ${soldOut ? "opacity-80" : ""}`}
          loading="lazy"
          onContextMenu={(e) => e.preventDefault()}
        />
      );
    } else {
      mainMedia = <div className="bg-gray-200 h-full w-full"></div>;
    }
  }

  return (
    <>
      <div
        className="h-full flex flex-col bg-white overflow-hidden card-hover group relative cursor-pointer"
        onClick={onCardClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Image Container */}
        <div
          className={`w-full relative aspect-[3/4] ${item.status === "Sold" ? "min-h-[120px] md:min-h-[160px] rounded" : "min-h-[180px] rounded-lg"} overflow-hidden`}
        >
          {mainMedia}
          {/* Status Tag */}
          {item.status && item.status !== "Sold" && (
            <div className="absolute bottom-3 md:bottom-auto md:top-3 left-3 md:left-auto md:right-3">
              <span
                className={`px-2 py-1 rounded-full text-[10px] md:text-[11px] font-medium ${getStatusColor(item.status)}`}
              >
                {item.status}
              </span>
            </div>
          )}
        </div>

        {/* Content */}
        {!condensedView && item.status !== "Sold" && (
          <div className="py-4 md:py-6 flex flex-col w-full justify-between">
            <div className="top">
              {/* Designer and Year */}
              <div className="mb-2">
                <h3 className="text-xl md:text-3xl text-gray-900 mb-1">
                  {item.designer}
                </h3>
              </div>

              <div className="hidden md:block">
                <span className="text-xs text-gray-800 line-clamp-2 mb-4">
                  {item.description}
                </span>
              </div>

              <div className="flex gap-1 md:gap-2">
                <span className="text-xs text-gray-800">
                  {formatSeason(item.season)} {item.year}
                </span>
                <span className="text-xs text-gray-800">•</span>
                {item.leadtime && (
                  <span className="text-xs text-gray-800">
                    {item.leadtime.includes("days") ||
                    item.leadtime.includes("week") ? (
                      <span className="hidden md:inline-block mr-1">
                        {" "}
                        Lead time:{" "}
                      </span>
                    ) : null}
                    {item.leadtime.includes("days") ||
                    item.leadtime.includes("week")
                      ? item.leadtime
                      : item.leadtime}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ItemCard;
